import { request } from "@/request/http";

export default {
  showCenterCourseList: (data) => {
    return request("POST", `/index.php/center/showCenterCourseList`, data);
  },

}
